import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { firebaseApp } from './firebase';
import type { PartPhoto } from '@/types/Part';

const storage = getStorage(firebaseApp);

function safeFilename(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9.-]+/g, '-').replace(/-+/g, '-');
}

export async function uploadPartPhoto(
  partId: string,
  file: File,
  alt: string,
  order: number
): Promise<PartPhoto> {
  const filename = `${Date.now()}-${safeFilename(file.name)}`;
  const path = `parts/${partId}/${filename}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type });
  const url = await getDownloadURL(r);
  return { url, storagePath: path, alt, order };
}

export async function deletePartPhoto(storagePath: string): Promise<void> {
  if (!storagePath) return;
  try {
    await deleteObject(ref(storage, storagePath));
  } catch (err) {
    // Object may already be gone — non-fatal.
    console.warn('deletePartPhoto failed (already missing?)', err);
  }
}
